(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-collection-product-grid-midevv"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function closeAllPopovers(popovers) {
    if (!popovers) return;
    popovers.forEach(function(p) {
      p.setAttribute('aria-hidden', 'true');
      var btn = document.querySelector('[aria-controls="' + p.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    // Re-enable body scrolling when all popovers are closed
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function preventBodyScroll() {
    // Prevent body scrolling when popover is open
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function initSortPopovers(root) {
    root = root || document;

    // Target popovers by exact IDs (no section_id suffix)
    var sortButtons = root.querySelectorAll(
      '[aria-controls="collection-sort-popover"],' +
      '[aria-controls="collection-sort-popover-mobile"]'
    );
    var popovers = root.querySelectorAll(
      '#collection-sort-popover,#collection-sort-popover-mobile'
    );
    var closeButtons = root.querySelectorAll(
      '#collection-sort-popover .Popover__Close,' +
      '#collection-sort-popover-mobile .Popover__Close'
    );
    var sortValues = root.querySelectorAll(
      '#collection-sort-popover [data-action="select-value"],' +
      '#collection-sort-popover-mobile [data-action="select-value"]'
    );

    if (!sortButtons.length || !popovers.length) return;

    // Function to position popover below button (using fixed positioning)
    function positionPopover(button, popover) {
      if (!button || !popover) return;
      
      var buttonRect = button.getBoundingClientRect();
      
      // Position popover below the button, aligned to the right
      // Using fixed positioning, so use viewport coordinates directly (no scroll offsets)
      var top = buttonRect.bottom + 4;
      var right = window.innerWidth - buttonRect.right;
      
      // Clamp to viewport if near edge
      var popoverWidth = popover.offsetWidth || 200;
      if (right < 0) {
        right = 8; // Small margin from left edge
      }
      
      popover.style.top = top + 'px';
      popover.style.right = right + 'px';
      popover.style.left = 'auto';
      popover.style.bottom = 'auto';
    }

    // Toggle popovers
    sortButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to click-outside handler
        var popoverId = this.getAttribute('aria-controls');
        var popover = document.getElementById(popoverId);
        if (!popover) return;

        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other popovers first
        closeAllPopovers(popovers);

        if (!isExpanded) {
          // Position popover below the button before showing
          positionPopover(this, popover);
          popover.setAttribute('aria-hidden', 'false');
          this.setAttribute('aria-expanded', 'true');
          // Prevent body scrolling when popover opens
          preventBodyScroll();
        } else {
          // If already expanded, close it
          popover.setAttribute('aria-hidden', 'true');
          this.setAttribute('aria-expanded', 'false');
          closeAllPopovers(popovers);
        }
      });
    });

    // Prevent popover clicks from closing it
    popovers.forEach(function(popover) {
      popover.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent clicks inside popover from bubbling to click-outside handler
      });
    });

    // Close popovers
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to click-outside handler
        var popover = this.closest('.Popover');
        if (!popover) return;
        popover.setAttribute('aria-hidden', 'true');
        var toggle = document.querySelector('[aria-controls="' + popover.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        // Re-enable body scrolling when popover closes
        closeAllPopovers(popovers);
      });
    });

    // Escape key to close popovers
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var openPopovers = document.querySelectorAll('#collection-sort-popover[aria-hidden="false"], #collection-sort-popover-mobile[aria-hidden="false"]');
        if (openPopovers.length > 0) {
          closeAllPopovers(openPopovers);
        }
      }
    });

    // Handle sort selection
    sortValues.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to click-outside handler
        var sortValue = this.getAttribute('data-value');
        if (!sortValue) return;

        // Re-enable scrolling before redirect
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        try {
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('sort_by', sortValue);
          window.location.href = currentUrl.toString();
        } catch (err) {
          console.error('Sort URL error:', err);
        }
      });
    });

    // Close popover when clicking outside (with small delay to prevent immediate closing)
    var clickOutsideTimer = null;
    document.addEventListener('click', function(e) {
      var clickedPopover = e.target.closest('#collection-sort-popover, #collection-sort-popover-mobile');
      var clickedButton = e.target.closest('[aria-controls="collection-sort-popover"], [aria-controls="collection-sort-popover-mobile"]');
      var clickedSortValue = e.target.closest('[data-action="select-value"]');
      var clickedCloseButton = e.target.closest('.Popover__Close');
      
      // Clear any pending close timer
      if (clickOutsideTimer) {
        clearTimeout(clickOutsideTimer);
        clickOutsideTimer = null;
      }
      
      // If clicking inside popover, button, sort value, or close button, don't close
      if (clickedPopover || clickedButton || clickedSortValue || clickedCloseButton) {
        return;
      }
      
      // Small delay to prevent immediate closing when button is clicked
      clickOutsideTimer = setTimeout(function() {
        var openPopovers = document.querySelectorAll('#collection-sort-popover[aria-hidden="false"], #collection-sort-popover-mobile[aria-hidden="false"]');
        if (openPopovers.length > 0) {
          closeAllPopovers(openPopovers);
        }
      }, 10);
    });

    // Reposition popover on scroll/resize
    function handleReposition() {
      var openPopovers = document.querySelectorAll('#collection-sort-popover[aria-hidden="false"], #collection-sort-popover-mobile[aria-hidden="false"]');
      openPopovers.forEach(function(popover) {
        var button = document.querySelector('[aria-controls="' + popover.id + '"]');
        if (button) {
          positionPopover(button, popover);
        }
      });
    }

    window.addEventListener('scroll', handleReposition, true);
    window.addEventListener('resize', handleReposition);
  }

  function init() {
    initSortPopovers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(event) {
    var container = event.target;
    if (!container) return;
    setTimeout(function() {
      initSortPopovers(container);
    }, 100);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
